<div class="border-solid -border-2 rounded-md p-2 border-gray-200 -bg-gray-100 drop-shadow-sm">
  <a routerLink="/tea-item/{{ teaItem.slug }}">
    <h2 class="text-xl font-bold text-green-900 text-center pb-2">{{ teaItem.name }} </h2>
  </a>
  <a routerLink="/tea-item/{{ teaItem.slug }}">
    <img [src]="teaItem.imageURL | imageModifier:{width:800} | async" alt="" class="rounded-md dropshadow" >
  </a>
  <!-- <p>
    {{ teaItem.description | slice:0:100 }}...
  </p> -->
  <!-- <p class="text-center">
    <span class="font-semibold text-green-700"><a routerLink="/tea-item/{{ teaItem.slug }}">Learn More...</a></span>
  </p> -->
  <!-- {{teaItem.imageURL|json}} -->
</div>
